export function CompareIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
      <path d="M33 24L26.7 30.0622L26.7 17.9378L33 24Z" fill="#593B37" />
      <path
        d="M13.5996 24L19.8996 30.0622L19.8996 17.9378L13.5996 24Z"
        fill="#593B37"
      />
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" />
    </svg>
  );
}
